import { Amplify } from 'aws-amplify';

export const configureAmplify = () => {
  Amplify.configure({
    Auth: {
      Cognito: {
        userPoolId: process.env.REACT_APP_COGNITO_USER_POOL_ID || 'us-east-1_GGbfrZ6Xr',
        userPoolClientId: process.env.REACT_APP_COGNITO_CLIENT_ID || '5ar8680u0ela1u6ultkno9tbku',
        loginWith: {
          oauth: {
            domain: process.env.REACT_APP_COGNITO_DOMAIN || 'kraftkennedy.auth.us-east-1.amazoncognito.com',
            scopes: ['openid', 'email'],
            redirectSignIn: [window.location.origin],
            redirectSignOut: [window.location.origin],
            responseType: 'code'
          }
        }
      }
    },
    API: {
      REST: {
        automunity: {
          endpoint: process.env.REACT_APP_API_URL || 'https://du3jj38v6l.execute-api.us-east-1.amazonaws.com/v1',
          region: 'us-east-1'
        }
      }
    }
  });
};
